import { FormConfig } from '../../../../components/Form';

export const TERMS_AND_CONDITIONS_CONFIG: FormConfig = {
  description: {
    fieldType: 'richText',
    placeholder: 'Edit Terms and Conditions',
  },
};
